import React, { Component } from 'react';
import * as bActs from '../actions/blog-actions';
import * as wActs from '../actions/website-actions';
import {Link} from 'react-router-dom'
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import { FormattedDate } from 'react-intl';
import NotFound from "../components/notfound";
import SmallBlogList from "../components/smallbloglist";
import EPomBanner from "../components/epombanner";
import * as wConsts from "../consts/website-consts";
import SwBanner from "../components/swbanner";
import BuyAdsBanner from "../components/buyadsbanner";
class BlogPost extends Component {

  componentWillMount() {
    //this.props.dispatch(bActs.GetBlogPost(this.props.match.params.slug));
  }
  componentDidMount() {
    if(this.props.Post.Loaded) {
      this.BlogPost.innerHTML = this.props.Post.Result.Result.Body;
    }
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "blogpost" });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  render() {
    let loc = typeof window === "undefined" ? "" : window.location.href;
    if (this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    let blogPost = () => {
      return (
        <p style={{display: "flex", alignContent: "center", justifyContent: "center" }}>
          <img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif?v=13`} width={"100px"} height={"100px"} alt={"Loading"} />
        </p>
      );
    };
    const loaded = this.props.Post.Loaded;
    const code = this.props.Post.Result.Code;
    if(loaded && code === 200) {
      const post = this.props.Post.Result.Result;
      const title = post.Title;
      const featuredImg = post.Image;
      let showImage = bActs.showImage(featuredImg.Width, featuredImg.Height);
      if(!this.props.WebPage.Settings.ShowFeaturedImagesInBlogPosts) {
        showImage = false;
      }

      blogPost = () => {
        return (
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="section-title">
                  <h1 style={{fontSize: "3.5rem"}}>{post.Title}</h1>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <div className="post-wrapper inner-post">
                  {showImage &&
                    <div className="post-cover">
                      <img src={post.Image.Url} alt={post.Title} />
                    </div>
                  }
                  <article className="post-description blog-post">
                    <p ref={(ref) => {this.BlogPost = ref}} dangerouslySetInnerHTML={{__html: post.Body}}></p>
                  </article>
                  <div className="post-info">
                    <ul>
                      <li className="post-share">Share:
                        <a href={"https://www.facebook.com/sharer/sharer.php?u=" + escape(loc)} target={"_blank"}><i className="fa fa-facebook" aria-hidden="true"></i></a>
                        <a href={"https://twitter.com/home?status=" + escape(loc)} target={"_blank"}><i className="fa fa-twitter" aria-hidden="true"></i></a>
                      </li>
                      <li className="post-categorie">Categories: {post.Categories.map((cv,i) => { return <span key={"cat-" + i} style={{margin: "2px"}}>{cv.Name}</span>})}</li>
                      <li><FormattedDate value={post.PublishedDate} weekday="long" day="2-digit" month="long" year="numeric"  /></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-sm-4">
                <div className="blog-sidebar">
                  <div className="widget-wrapper">
                    <h5>Share</h5>
                    <div className="post-search">
                      <a href={"https://www.facebook.com/sharer/sharer.php?u=" + escape(loc)} target={"_blank"}><i className="fa fa-facebook" aria-hidden="true" style={{fontSize: "3.5rem", marginRight: "10px"}}></i></a>
                      <a href={"https://twitter.com/home?status=" + escape(loc)} target={"_blank"}><i className="fa fa-twitter" aria-hidden="true" style={{fontSize: "3.5rem"}}></i></a>
                    </div>
                  </div>
                  <div className="widget-wrapper">
                    <h5>Categories</h5>
                    <ul className="column_links">
                      {post.Categories.map((cv,i) => {
                        return <li style={{position: "unset"}} key={cv.Name + "-" + i}>{cv.Name}</li>
                      })}
                    </ul>
                  </div>

                  <div className="widget-wrapper">
                    <h5>Latest posts</h5>
                    <SmallBlogList/>
                  </div>
                  <div className="widget-wrapper">
                    <div className="promo-sidebar" style={{maxWidth: "200px", marginLeft: "55px"}}>
                      <div className="flex-center-vertical">
                        <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x333-featured']} className="opartners-list">
                          <BuyAdsBanner size="200x333" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                        </SwBanner>
                      </div>
                      <div className="flex-center-vertical">
                        <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-featured']} className="opartners-list" >
                          <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                        </SwBanner>
                      </div>
                      <div className="flex-center-vertical">
                        <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x333-sidebar']} className="opartners-list" >
                          <BuyAdsBanner size="200x333" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                        </SwBanner>
                      </div>
                      <div className="flex-center-vertical">
                        <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-sidebar']} className="opartners-list" >
                          <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                        </SwBanner>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      };
    }

    return (
      <div className="blog-wrapper">
        {blogPost()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Post: state.Blog.BlogPages
  };
}

export default connect(mapStateToProps)(BlogPost);
